import { render, staticRenderFns } from "./pointChart.vue?vue&type=template&id=45c8b60b&"
import script from "./pointChart.vue?vue&type=script&lang=js&"
export * from "./pointChart.vue?vue&type=script&lang=js&"
import style0 from "./pointChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports